import { appState } from "$lib/stores/AppState.svelte";
import { EnvironmentsApi, UsersApi } from "./lib/api";
import { Identity } from "./lib/shared/services/IdentityService";
import { LicenseManager } from "ag-grid-enterprise";

const agGridKey = import.meta.env.VITE_AG_GRID_LICENSE_KEY;

/** @type {import("@sveltejs/kit").ClientInit} */
export async function init() {
    try {
        appState.config = await EnvironmentsApi.getConfig();

        let isSessionValid = await Identity.initialize({
            url: appState.config.keyCloakUrl,
            clientId: appState.config.keyCloakClientId,
            realm: appState.config.keyCloakRealm,
            logoutRedirectUri: appState.config.keyCloakLogoutRedirect
        });

        if (!isSessionValid) return {};

        LicenseManager.setLicenseKey(agGridKey);

        return {};
    }
    catch(error) {
        console.error(error);
    }
}